<template>
  <div class="miya-purchasedDetails" id="miya-purchasedDetails">
    <div class="pageBox">
      <h1 class="title1 fontSH" style="width:30%;display:inline-block;">
        {{ $t("pAgent.title2") }}
      </h1>
      <el-alert
        style="width:30%;display:inline-block;"
        :title="$t('pAgent.tips')"
        type="warning"
      >
      </el-alert>
      <div class="search-box">
        <check-list
          class="checkList"
          :list="tabList"
          :default="[activeTab]"
          @change="changeTab"
        ></check-list>
        <div class="select-box">
          <el-select
            style="width:100%;"
            size="medium"
            :placeholder="$t('pAgent.country')"
            v-model="country"
            clearable
            @change="getDataList()"
          >
            <el-option
              v-for="(item, idx) in countryList"
              :key="'country' + idx"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="search-input">
          <el-input
            size="medium"
            v-model="searchText"
            :placeholder="$t('pAgent.placeholderSearch')"
            clearable
            @change="getDataList()"
            ><i slot="suffix" class="el-input__icon el-icon-search"></i
          ></el-input>
        </div>
      </div>
      <div class="table-data">
        <el-table
          ref="multipleTable"
          row-key="id"
          :cell-style="{ 'text-align': 'center' }"
          :data="tableData"
          :highlight-selection-row="true"
          :max-height="tableHeight"
          v-loading="tableLoading"
          style="width: 100%;"
          @selection-change="selectionChange"
        >
          <el-table-column
            type="selection"
            :reserve-selection="true"
            width="35"
          >
          </el-table-column>
          <el-table-column
            prop="qr"
            :label="$t('dashboard.s5qr')"
            width="180px"
          >
            <template slot-scope="scope">
              <el-popover
                placement="bottom-start"
                title=""
                width="134"
                trigger="hover"
                content=""
                @show="showQrCode(scope.row)"
              >
                <div class="qrcode" slot="reference">
                  <span>{{ $t("dashboard.s5qr") }}</span>
                </div>
                <div class="miya-dashboard-qr-img-box">
                  <div
                    :id="`QRImg${scope.row.id}`"
                    :ref="`QRImg${scope.row.id}`"
                  ></div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            :label="$t('dashboard.expirationTime')"
            width="130px"
          >
            <template slot-scope="scope">
              <p v-html="getTime(scope.row.createTime)"></p>
            </template>
          </el-table-column>
          <el-table-column
            prop="type"
            :label="$t('dashboard.typeString')"
            min-width="70"
          >
            <template slot-scope="scope">
              <!-- <p class="type-name">{{$t('home.pTitle3')}}</p> -->
              <div class="value-box">
                <!-- <label>{{$t('home.pSubtitile4')}}</label> -->
                <label v-if="scope.row.mealType === 3" class="type"
                  >{{ $t("pAgent.type1") }}-{{ scope.row.country }}</label
                >
                <label v-if="scope.row.mealType === 4" class="type"
                  >{{ $t("pAgent.type2") }}-{{ scope.row.country }}</label
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="proxy"
            :label="$t('pAgent.t1')"
            min-width="110"
          >
            <template slot-scope="scope">
              <div class="s5TextBox">
                <span>{{ scope.row.origins5Proxy }}</span>
                <div class="copyeBtnBox">
                  <el-button
                    type="primary"
                    size="mini"
                    class="copyBtn"
                    :class="'copyBtn1' + scope.row.id"
                    :data-clipboard-text="scope.row.origins5Proxy"
                    @click="clickCopye(`copyBtn1${scope.row.id}`)"
                    >{{ $t("pCountry.copy") }}</el-button
                  >
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="proxy"
            :label="$t('pAgent.t2')"
            min-width="110"
          >
            <template slot-scope="scope">
              <div class="s5TextBox">
                <span>{{ scope.row.originhttpProxy }}</span>
                <div class="copyeBtnBox">
                  <el-button
                    type="primary"
                    size="mini"
                    class="copyBtn"
                    :class="'copyBtn4' + scope.row.id"
                    :data-clipboard-text="scope.row.originhttpProxy"
                    @click="clickCopye(`copyBtn4${scope.row.id}`)"
                    >{{ $t("pCountry.copy") }}</el-button
                  >
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="proxy"
            :label="$t('pAgent.t3')"
            min-width="110"
          >
            <template slot-scope="scope">
              <div class="s5TextBox">
                <span>{{ scope.row.s5Proxy }}</span>
                <div class="copyeBtnBox">
                  <el-button
                    type="primary"
                    size="mini"
                    class="copyBtn"
                    :class="'copyBtn2' + scope.row.id"
                    :data-clipboard-text="scope.row.s5Proxy"
                    @click="clickCopye(`copyBtn2${scope.row.id}`)"
                    >{{ $t("pCountry.copy") }}</el-button
                  >
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="proxy"
            :label="$t('pAgent.t4')"
            min-width="110"
          >
            <template slot-scope="scope">
              <div class="s5TextBox">
                <span>{{ scope.row.httpProxy }}</span>
                <div class="copyeBtnBox">
                  <el-button
                    type="primary"
                    size="mini"
                    class="copyBtn"
                    :class="'copyBtn3' + scope.row.id"
                    :data-clipboard-text="scope.row.httpProxy"
                    @click="clickCopye(`copyBtn3${scope.row.id}`)"
                    >{{ $t("pCountry.copy") }}</el-button
                  >
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="remark"
            :label="$t('dashboard.remark')"
            min-width="100"
          >
            <template slot-scope="scope">
              <input
                type="text"
                v-model="scope.row.remark"
                style="border: none;"
                :placeholder="$t('dashboard.remarkplaceholder')"
                :readonly="scope.row.isreadonly"
                @click="scope.row.isreadonly = false"
                @blur="rowBlur(scope.row)"
              />
            </template>
          </el-table-column>
          <el-table-column prop="" :label="$t('pAgent.operation')" width="190">
            <template slot-scope="scope">
              <!-- <el-button type="error" size="medium" style="width:80px;" @click="clickRenew(scope.row)">{{$t('pAgent.addRemark')}}</el-button> -->
              <el-button
                type="primary"
                size="medium"
                style="width:80px;"
                @click="clickRenew(scope.row)"
                >{{ $t("pAgent.btnRenew") }}</el-button
              >
              <el-button
                type="info"
                class="btn-delete"
                style="width:80px;"
                size="medium"
                @click="clickDelete(scope.row)"
                >{{ $t("pAgent.btnDel") }}</el-button
              >
            </template>
          </el-table-column>
          <div slot="empty" class="table_nodata">
            <img
              v-if="!tableLoading"
              class="nodata"
              src="@/assets/images/home/noData.png"
              height="240"
              alt=""
            />
            <p v-if="!tableLoading" class="nodataText">
              {{ $t("home.noData") }}
            </p>
          </div>
        </el-table>
      </div>
      <div class="price-box">
        <div class="selection">
          <div class="slection-box" v-if="selectList.length > 0">
            <p class="selectText">{{ $t("pAgent.select") }}</p>
            <p class="total">{{ selectList.length }}</p>
            <p class="unit">[{{ $t("pAgent.unit") }}]</p>
            <el-button
              type="primary"
              class="btn-mutRenew"
              size="medium"
              @click="clickMutRenew()"
              >{{ $t("pAgent.mutRenew") }}</el-button
            >
            <el-button
              type="info"
              size="medium"
              class="btn-delete "
              @click="clickMutDelete()"
              >{{ $t("pAgent.mutDel") }}</el-button
            >
            <el-button
              type="info"
              size="medium"
              class="btn-delete "
              @click="clickMutCancel()"
              >{{ $t("pAgent.mutCancel") }}</el-button
            >
          </div>
        </div>
        <div class="pagination">
          <p class="exportBtn" @click.stop="clickExport()">
            {{ $t("pAgent.btnExport") }}
          </p>
          <el-pagination
            size="medium"
            layout="total, sizes, prev, pager, next"
            :page-sizes="[8, 20, 30, 50]"
            :page-size="pageSize"
            :current-page="page"
            :pager-count="5"
            :total="total"
            @size-change="changeDataSize"
            @current-change="changePage"
          ></el-pagination>
        </div>
      </div>

      <el-dialog
        :visible.sync="centerDialogVisible"
        title="Warning"
        width="500"
        center
      >
        <el-input
          v-model="changeIp"
          style="width: 240px"
          placeholder="输入ip，如127.0.0.1"
        />
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="centerDialogVisible = false">Cancel</el-button>
            <el-button type="primary" @click="confirmChange">
              Confirm
            </el-button>
          </div>
        </template>
      </el-dialog>

      <el-dialog
        title=""
        :visible.sync="dialogRenew"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :width="pageWidth < 800 ? '94%' : '524px'"
      >
        <div class="renewList">
          <div class="amount"><span class="usd">$</span>{{ amount }}</div>
          <div class="amountText">{{ $t("pTraffic.amount") }}</div>
          <p class="titleName">
            {{ $t("pAgent.renewIP")
            }}<span class="total">{{ getIspLength }}</span
            ><span class="unit">/ {{ $t("dashboard.orders") }}</span>
          </p>
          <p class="titleName">{{ $t("pAgent.renewTime") }}</p>
          <check-list
            :list="dayList"
            :default="[month]"
            @change="changeDayChecked"
          ></check-list>
          <p class="titleName">{{ $t("pTraffic.discountCode") }}</p>
          <el-input
            size="medium"
            clearable
            :placeholder="$t('pTraffic.placeholderDc')"
            v-model="discountCode"
            @change="changeDc()"
          ></el-input>
        </div>
        <div class="dialog-footer renew-footer">
          <el-button
            class="ok"
            type="info"
            style="border-radius:0;"
            @click.stop="clickUSDT()"
            >{{ $t("pTraffic.btnUsdt") }}</el-button
          >
          <p class="otherTitle">{{ $t("pTraffic.otherPay") }}</p>
          <div class="list">
            <div class="item" @click.stop="clickPay('alipay')">
              <img class="icon" src="@assets/images/dynamic/zfb.png" /><span>{{
                $t("pTraffic.Alipay")
              }}</span>
            </div>
            <div class="item" @click.stop="clickPay('native')">
              <img class="icon vx" src="@assets/images/dynamic/vx.png" /><span
                >{{ $t("pTraffic.WeChat") }}</span
              >
            </div>
          </div>
          <div class="list">
            <!-- <div class="item" @click.stop="clickPay('stripe')">
              <img class="mc" src="@assets/images/dynamic/other.svg" />
            </div> -->
            <div class="item" @click.stop="clickPay('useepay')">
              <img class="mc" src="@assets/images/dynamic/other.svg" />
            </div>
            <!-- <div class="item" @click.stop="clickPay('paypal')">
              <img class="mc" src="@assets/images/dynamic/pp_fc_hl.svg" />
            </div> -->
          </div>
        </div>
      </el-dialog>
      <el-dialog
        :title="loadQr ? '' : $t('pTraffic.payUSDT')"
        :visible.sync="dialogTableUSDT"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :width="loadQr ? '240px' : '360px'"
      >
        <div class="qrImg" v-if="loadQr">
          <img class="loading" src="@assets/images/home/load.gif" />
          <p class="text">{{ $t("pTraffic.loading") }}</p>
        </div>
        <div class="usdt-box" v-if="!loadQr">
          <p class="usdt">
            <span class="value">{{ USDT }}</span
            ><span class="unit">USDT</span>
          </p>
          <p class="old" v-show="discount < 1">
            <span class="value">{{ oldUSDT }}</span
            ><span class="unit">USDT</span>
          </p>
        </div>
        <div class="dialog-footer" v-if="!loadQr">
          <el-button
            class="ok"
            type="info"
            size="medium"
            :disabled="usdtSurplus < USDT"
            @click.stop="clickPayUSDT()"
            >{{
              usdtSurplus < USDT ? $t("login.balance1") : $t("pTraffic.payOk")
            }}</el-button
          >
          <div class="cancel-usdt">
            <span @click.stop="dialogTableUSDT = false">{{
              $t("pTraffic.payCancel")
            }}</span>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        :title="payTitle"
        :visible.sync="dialogTablePayCode"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :width="loadQr ? '240px' : '360px'"
      >
        <div class="qrImg" v-if="loadQr">
          <img class="loading" src="@assets/images/home/load.gif" />
          <p class="text">{{ $t("pTraffic.loading") }}</p>
        </div>
        <div class="qrImg" v-if="!loadQr">
          <img class="qrcode" :src="payQr" />
        </div>
        <div class="pay-dialog-price" v-if="!loadQr">
          <label class="name">{{ $t("pTraffic.amount") }}</label>
          <span class="old" v-show="discount < 1">￥{{ odlAmountRMB }}</span>
          <span class="unit">￥</span>
          <span class="amount">{{ amountRMB }}</span>
        </div>
        <div class="pay-footer" v-if="!loadQr">
          <el-button
            class="cancel miyaBtnInfo"
            type="info"
            size="medium"
            plain
            @click.stop="dialogTablePayCode = false"
            >{{ $t("pTraffic.payCancel") }}</el-button
          >
          <el-button
            class="ok"
            type="info"
            size="medium"
            @click.stop="clickPaid()"
            >{{ $t("pTraffic.paid") }}</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        title=""
        :visible.sync="dialogDelete"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="240px"
      >
        <div class="deleteWarning"><i class="el-icon-warning-outline"></i></div>
        <div class="deleteTitle">{{ $t("pAgent.deleteDialogTitle") }}</div>
        <div class="deleteText">{{ $t("pAgent.deleteDialogText") }}</div>
        <div class="pay-footer">
          <el-button
            class="cancel miyaBtnInfo"
            type="info"
            size="medium"
            plain
            @click.stop="dialogDelete = false"
            >{{ $t("pTraffic.payCancel") }}</el-button
          >
          <el-button
            class="ok"
            type="info"
            size="medium"
            @click.stop="clickDeleteData()"
            >{{ $t("login.btnOK") }}</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        class="dialogAdyen"
        :show-close="false"
        :visible.sync="dialogAdyen"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :width="pageWidth < 900 ? '90%' : '900px'"
        :top="pageWidth < 900 ? '5vh' : '10vh'"
      >
        <div class="adyenContent">
          <div class="close" @click="dialogAdyen = false">
            <i class="el-icon-close"></i>
          </div>
          <div class="dropin-container" id="dropin-container"></div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import miyaBtn from "@components/miyaBtn.vue";
import checkList from "@components/checkList.vue";
import moment from "moment";
import AdyenCheckout from "@adyen/adyen-web";
import { purchaseCity, dayList } from "@assets/js/data.js";
import QRCode from "qrcodejs2";
import { Base64 } from "js-base64";
import axios from "axios";
export default {
  data() {
    return {
      tabList: [
        { name: "", value: "-1" },
        { name: "", value: "3" },
        { name: "", value: "4" },
      ],
      tableData: [],
      dayList: dayList,
      month: 3,
      countryList: purchaseCity,
      activeTab: "-1",
      country: "",
      searchUser: "",
      searchText: "",
      priceTop: 0,
      total: 0,
      page: 1,
      pageSize: 8,
      changeIp: "",
      centerDialogVisible: false,
      tableLoading: false,
      selectList: [],
      ispId: "",
      renewType: 1, // 1单个续费， 2批量续费
      dialogRenew: false,
      amount: 0,
      oldAmount: 0,
      discount: 1,
      discountCode: "",
      USDT: 0,
      oldUSDT: 0,
      dialogTableUSDT: false,
      dialogTablePayCode: false,
      amountRMB: 0,
      odlAmountRMB: 0,
      payQr: "",
      discountCodeError: "",
      loadQr: false,
      payType: "",
      orderId: "",
      dialogDelete: false,
      deleteId: "",
      tableHeight: 0,
      dialogAdyen: false,
      currentChangeRow: undefined,
    };
  },
  computed: {
    ...mapGetters(["user"]),
    usdtSurplus() {
      return this.user.usdtSurplus || 0;
    },
    getIspLength() {
      if (this.renewType == 2) {
        return this.selectList.length;
      } else if (this.renewType == 1) {
        return 1;
      }
    },
    payTitle() {
      if (this.loadQr) {
        return "";
      } else {
        let type = "";
        if (this.payType === "alipay") {
          type = this.$t("pTraffic.Alipay");
        } else if (this.payType === "native") {
          type = this.$t("pTraffic.WeChat");
        }
        return `${type}${this.$t("pTraffic.payCode")}`;
      }
    },
    ...mapGetters(["user"]),
  },
  mounted() {
    this.getData();
    this.initEvent();
    this.getDataList();
    this.setTableHeight();
  },
  methods: {
    confirmChange() {
      this.$post(`/UserIsp/UpdateIsp`, {
        id: this.currentChangeRow.id,
        proxy: this.changeIp,
      }).then((res) => {
        if (res.code === 200) {
          this.centerDialogVisible = false;
          this.getDataList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    clickChange(row) {
      this.centerDialogVisible = true;
      this.currentChangeRow = row;
    },
    rowBlur(row) {
      row.isreadonly = true;
      this.$post(`/UserIsp/UpdateRemark`, {
        id: row.id,
        remark: row.remark,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success(this.$t("dashboard.remarkMsg"));
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getData() {
      this.tabList[0].name = this.$t("pAgent.all");
      this.tabList[1].name = this.$t("pAgent.type1");
      this.tabList[2].name = this.$t("pAgent.type2");
    },
    getDataList() {
      this.tableData = [];
      this.tableLoading = true;
      this.$get(`/UserIsp/Load`, {
        page: this.page,
        limit: this.pageSize,
        key: this.searchText,
        mealType: this.activeTab,
        searchUser: this.searchUser,
        country: this.country,
      }).then((res) => {
        this.tableLoading = false;
        if (res.code === 200) {
          res.data = res.data.map((val) => {
            val.isreadonly = true;
            return val;
          });
          this.tableData = res.data;
          this.total = res.count;
        }
      });
    },
    getHttpProxy(proxy) {
      let arr = proxy.split(":");
      if ((arr.length = 4)) {
        arr[1] = Number(arr[1]) + 1;
      }
      return arr.join(":");
    },
    clickCopye(btn) {
      var clipboard = new this.Clipboard(`.${btn}`);
      clipboard.on("success", () => {
        this.$message.success(this.$t("reward.copySuccess"));
        clipboard.destroy();
      });
      clipboard.on("error", () => {
        this.$message.error(this.$t("reward.copyError"));
        clipboard.destroy();
      });
    },
    changeDataSize(pageSize) {
      this.page = 1;
      this.pageSize = pageSize;
      this.getDataList();
    },
    changePage(page) {
      this.page = page;
      this.getDataList();
    },
    clickRenew(item) {
      this.renewType = 1;
      this.ispId = item.id;
      this.dialogRenew = true;
      this.getAmount();
      this.clickMutCancel();
      this.$refs.multipleTable.toggleRowSelection(item);
    },
    clickMutRenew() {
      this.renewType = 2;
      this.dialogRenew = true;
      this.getAmount();
    },
    clickPaid() {
      this.dialogTablePayCode = false;
      this.payDone();
    },
    clickExport() {
      axios
        .get(`${window.baseUrl}api/userisp/ExportExcel`, {
          headers: {},
          responseType: "arraybuffer",
          params: {},
        })
        .then((res) => {
          let blob = new Blob([res.data], {
            type: "application/vnd.ms-excel", //文件类型
          });
          let eLink = document.createElement("a");
          eLink.download = "isps.xlsx";
          eLink.style.display = "none";
          eLink.href = URL.createObjectURL(blob);
          document.body.appendChild(eLink);
          eLink.click();

          document.body.removeChild(eLink);
          URL.revokeObjectURL(eLink.href);
        });
      // window.open(window.baseUrl + 'api/userisp/ExportExcel', '_blank')
    },
    clickDelete(item) {
      this.dialogDelete = true;
      this.deleteId = item.id;
    },
    clickMutDelete() {
      this.dialogDelete = true;
      this.deleteId = this.selectList
        .map((val) => {
          return val.id;
        })
        .join(",");
    },
    clickDeleteData() {
      this.$get(`/UserIsp/Delete?ids=${this.deleteId}`).then((res) => {
        this.dialogDelete = false;
        if (res.code === 200) {
          this.$message.success(this.$t("login.success"));
          this.getDataList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getAmount() {
      // 获取单价
      let data = {
        renewdata: this.getRenewdata(),
        realPay: 0,
        month: this.month,
        discountKey: this.discountCode,
        payType: "usdt",
      };
      this.$get(`/ProxyBuy/RenewIsp`, data).then((res) => {
        if (res.code === 200) {
          this.amount = res.result.priceDao;
        }
      });
    },
    getRenewdata() {
      let renewdata = "";
      if (this.renewType === 1) {
        renewdata = this.ispId;
      } else if (this.renewType === 2) {
        renewdata = this.selectList
          .map((val) => {
            return val.id;
          })
          .join(",");
      }
      return renewdata;
    },
    changeDc() {
      // 获取折扣码
      if (this.discountCode) {
        this.$get(
          `/ProxyBuy/DiscountInfo?discountKey=${this.discountCode}`
        ).then((res) => {
          if (res.code === 200) {
            this.discount = Number(res.result);
            this.getAmount();
          } else if (res.code === 500) {
            this.discountCodeError = this.$t("pTraffic.discountCodeError");
          }
        });
      }
    },
    clickPay(type) {
      // 其他支付
      // if (type === 'adyen') {
      //   this.$message.warning(this.$t('pTraffic.commingSoon'))
      //   return
      // }
      this.showPayBox = false;
      this.dialogTablePayCode = true;
      this.payType = type;
      let data = {
        payType: type,
        renewdata: this.getRenewdata(),
        realPay: 1,
        month: this.month,
        discountKey: this.discountCode,
      };
      this.loadQr = true;
      this.$get(`/ProxyBuy/RenewIsp`, data).then((res) => {
        this.loadQr = false;
        if (res.code === 200) {
          if (this.payType === "adyen") {
            this.loadQr = true;
            this.getConfiguration(
              res.result.checkoutSessionid,
              res.result.sessionData
            );
          } else if (this.payType === "useepay") {
            window.open(res.result.sessionData, "_blank");
          } else if (this.payType === "stripe") {
            window.open(res.result.sessionData, "_blank");
          } else if (this.payType === "paypal") {
            window.open(res.result.sessionData, "_blank");
          } else if (this.payType === "rucredit") {
            window.open(res.result.payssionPayUrl, "_blank");
          } else {
            this.payQr = res.result.qr;
          }
          this.amountRMB = res.result.price;
          this.odlAmountRMB = Number(
            (res.result.price / this.discount).toFixed(2)
          );
        } else {
          this.dialogTablePayCode = false;
          this.$message.error(res.message);
        }
      });
    },
    async getConfiguration(sessionid, sessionData) {
      const configuration = {
        environment: "live", // Change to 'live' for the live environment.
        clientKey: "live_OX724TTSUZG7ZE5KUZF3EBMXRILZHW73", // Public key used for client-side authentication: https://docs.adyen.com/development-resources/client-side-authentication
        analytics: {
          enabled: true, // Set to false to not send analytics data to Adyen.
        },
        session: {
          id: sessionid, // Unique identifier for the payment session.
          sessionData: sessionData, // The payment session data.
        },
        onPaymentCompleted: (result, component) => {
          console.info(result, component);
        },
        onError: (error, component) => {
          console.error(error.name, error.message, error.stack, component);
        },
        // Any payment method specific configuration. Find the configuration specific to each payment method:  https://docs.adyen.com/payment-methods
        // For example, this is 3D Secure configuration for cards:
        paymentMethodsConfiguration: {
          card: {
            hasHolderName: true,
            holderNameRequired: true,
            billingAddressRequired: true,
          },
        },
      };
      const checkout = await AdyenCheckout(configuration);

      this.loadQr = false;
      this.dialogTablePayCode = false;
      this.dialogAdyen = true;
      this.$nextTick(() => {
        const dropinComponent = checkout
          .create("dropin")
          .mount("#dropin-container");
        dropinComponent.update();
      });
    },
    clickUSDT() {
      // USDT生成订单
      let data = {
        renewdata: this.getRenewdata(),
        realPay: 0,
        month: this.month,
        discountKey: this.discountCode,
        payType: "usdt",
      };
      this.dialogTableUSDT = true;
      this.loadQr = true;
      this.$get(`/ProxyBuy/RenewIsp`, data).then((res) => {
        this.loadQr = false;
        if (res.code === 200) {
          // this.orderId = res.result.orderId
          this.USDT = res.result.priceDao;
          this.oldUSDT = Number(
            (res.result.priceDao / this.discount).toFixed(2)
          );
        } else {
          this.$message.error(res.message);
        }
      });
    },
    clickPayUSDT() {
      // USDT支付
      let data = {
        payType: "usdt",
        renewdata: this.getRenewdata(),
        month: this.month,
        discountKey: this.discountCode,
        realPay: 1,
      };
      this.loadQr = true;
      this.$get(`/ProxyBuy/RenewIsp`, data).then((res) => {
        if (res.code === 200) {
          this.orderId = res.result.orderId;
          this.$get(`/ProxyBuy/UsdtCallback?orderId=${this.orderId}`).then(
            (res1) => {
              if (res1.code === 200) {
                this.dialogTableUSDT = false;
                this.payDone();
                this.$message.success(this.$t("login.success"));
                setTimeout(() => {
                  this.$get(`/Check/GetInfo`).then((res2) => {
                    if (res2.code === 200) {
                      this.$store.commit("set_user", res2.result);
                    }
                  });
                }, 200);
              } else {
                this.$message.error(res1.message);
              }
            }
          );
        } else {
          this.loadQr = false;
          this.dialogTableUSDT = false;
          this.$message.error(res.message);
        }
      });
    },
    showQrCode(item) {
      this.$nextTick(() => {
        this.getQrCode(item.s5Proxy, item.id);
      });
    },
    getQrCode(proxy, id) {
      $(`#QRImg${id}`).html("");
      const proxySplit = proxy.split(":");
      let str = Base64.encode(
        `${proxySplit[2]}:${proxySplit[3]}@${proxySplit[0]}:${proxySplit[1]}`
      );
      let codeString = `socks://${str}?obfs=none`;
      let qr = new QRCode(this.$refs[`QRImg${id}`], {
        width: 108,
        height: 108,
      });
      qr.makeCode(codeString);
    },
    payDone() {
      this.loadQr = false;
      this.dialogRenew = false;
      this.getData();
      this.getDataList();
      this.clickMutCancel();
    },
    clickMutCancel() {
      this.$refs.multipleTable.clearSelection();
    },
    getTime(time) {
      return (
        moment(time).format("YYYY-MM-DD") +
        "<br/>" +
        moment(time).format("HH:mm:ss")
      );
    },
    changeTab(list) {
      this.activeTab = list[0].value;
      this.getDataList();
    },
    selectionChange(list) {
      this.selectList = list;
    },
    changeDayChecked(list) {
      this.month = list[0].value;
      this.getAmount();
    },
    resetTop() {
      let height = $("#miya-purchasedDetails").innerHeight();
      let scrollT = $(window).scrollTop();
      let wH = window.innerHeight;
      let top = scrollT + wH;
      if (top < height) {
        this.priceTop = top - 65;
      } else {
        this.priceTop = height - 65;
      }
    },
    setTableHeight() {
      if (this.$refs.multipleTable) {
        setTimeout(() => {
          this.tableHeight = $("#miya-purchasedDetails").innerHeight() - 260;
          if (this.pageWidth < 800) {
            this.tableHeight = 700;
          }
          this.$refs.multipleTable.doLayout();
        }, 100);
      }
    },
    initEvent() {
      $(window).bind("resize", () => {
        this.setTableHeight();
      });
    },
  },
  beforeDestroy() {
    // $(window).unbind('resize')
  },
  watch: {
    language() {
      this.getData();
    },
  },
  components: { miyaBtn, checkList },
};
</script>
<style scoped lang="stylus">
.miya-purchasedDetails
  height 100%
  overflow-y hidden
  .pageBox
    min-height 100%
    padding 40px 40px 24px 40px
    position relative
  .title1
    color $c1
    font-size 28px
    margin 10px 0 32px 0
  .search-box
    display flex
    .checkList
      flex 1
      .item
        width 130px
    .select-box, .search-input
      width 20%
    .select-box
      margin-right 36px
  .table-data
    margin 32px 0 60px 0
    min-height 50vh
    height 70vh
    .qrcode
      color $c1
      font-size $f14
      background $c7
      padding 4px 12px
      position relative
      display inline-block
      border 1px solid #E0E0E0
      &:hover
        box-shadow: 0px 4px 8px 1px rgba(20,17,14,0.1);
    .type-name
      color $c1
      font-size $f14
      fontWeight()
      margin-bottom 6px
    .value-box
      line-height 20px
      color $c1
      font-size $f14
      display flex
      .type
        fontWeight()
        color $c8
    .s5TextBox
      position relative
      .copyeBtnBox
        position absolute
        display none
        top 0
        left 0
        width 100%
        height 100%
        background-color rgba(255,251,245,0.6)
        animation moveIn .3s ease forwards
        .copyBtn
          position absolute
          top 50%
          left 50%
          transform translate3d(-50%, -50%, 0)
      &:hover
        .copyeBtnBox
          display block
  .price-box
    position absolute
    z-index 5
    left 0
    bottom 0
    width 100%
    border-top 1px solid $c4
    background-color $c7
    display flex
    .selection
      padding 15px 0 15px 36px
      line-height 36px
      display flex
      flex 1
      .slection-box
        display flex
        line-height 36px
        .selectText, .unit
          font-size $f14
          margin-right 10px
          color $c1
        .total
          color $c8
          font-size $f20
          fontWeight()
          margin-right 6px
          position relative
          top -3px
        .btn-mutRenew
          margin-left 40px
    .pagination
      padding 17px 36px
      display flex
      .exportBtn
        line-height 28px
        margin-right 24px
        cursor pointer
        color $c8
        font-size $f14
        &:hover
          fontWeight()
  .renewList
    padding 0 12px
    .amount
      color $c8
      fontWeight()
      line-height 40px
      font-size 36px
      display flex
      justify-content center
      .usd
        font-size 24px
        margin-right 6px
    .amountText
      text-align center
      color $c1
      margin-top 8px
      font-size $f14
    .titleName
      display flex
      color $c1
      line-height 20px
      fontWeight()
      font-size $f14
      margin 24px 0 10px 0
      .total
        font-size $f20
        margin 0 6px 0 30px
        position relative
        top -2px
      .unit
        font-size $f14
        color $c2
        font-weight 300

  .usdt-box
    padding 56px 0
    text-align center
    .usdt
      color $c10
      margin-bottom 24px
      .value
        font-size 40px
        margin-right 8px
      .unit
        font-size $f14
    .old
      color $c2
      position relative
      display inline-block
      margin 0 auto
      padding 0 4px
      line-height 12px
      .value
        font-size $f24
        margin-right 8px
      .unit
        font-size $f14
      &:before
        content ''
        position absolute
        width 100%
        height 1px
        background-color $c2
        top 50%
        left 0
  .pay-footer
    display flex
    padding-bottom 24px
    .ok, .cancel
      flex 1
  .dialog-footer
    padding-bottom 24px
    .disabeld
      color $c10
      text-align center
      padding-bottom 8px
  .renew-footer
    padding 32px 12px
    .otherTitle
      font-size $f12
      color $c2
      margin 24px 0 10px 0
    .list
      display flex
      .item
        flex 1
        display flex
        padding 12px
        line-height 20px
        border 1px solid $c5
        border-radius 2px
        margin-right 24px
        cursor pointer
        background-color $c7
        box-shadow: 0px 4px 8px 1px rgba(20,17,14,0.1);
        .icon
          width 20px
          margin-right 12px
        .vx
          width 22px
        .mc
          height 20px
        .vs
          height 16px
        span
          color $c1
          font-size $f16
        &:last-child
          margin-right 0
        &:hover
          background-color $c6
  .pay-dialog-price
    margin 42px 0 12px 0
    display flex
    line-height 24px
    .name
      font-size $f14
      fontWeight()
      flex 1
    .old
      color $c2
      font-size $f14
      margin-right 12px
      text-decoration: line-through
    .unit
      color $c10
      font-size $f16
      margin-right 6px
    .amount
      color $c10
      font-size $f24
      position relative
      top -3px
  .qrImg
    .qrcode, .loading
      display block
      margin 0 auto
    .loading
      width 124px
      margin-top 2px
    .qrcode
      margin-top 12px
    .text
      padding 24px 0 42px 0
      text-align center
      font-size $f14
      color $c2
      line-height 22px
  .cancel-usdt
    text-align center
    color $c2
    span
      cursor pointer
      &:hover
        color $c1
  .deleteWarning
    text-align center
    font-size 56px
    color $c8
  .deleteTitle
    font-size $f16
    color $c10
    text-align center
    margin 24px 0 12px 0
  .deleteText
    font-size $f14
    color $c2
    text-align center
    margin-bottom 32px
  .dialogAdyen
    >>>.el-dialog
      margin 5vh auto 0 auto
    >>>.el-dialog__header
      padding 0
  .adyenContent
    position relative
    .close
      position absolute
      right -30px
      top -30px
      font-size 16px
      color #fff
      border-radius 50%
      padding 6px
      border 1px solid rgba(255,255,255,0.5)
      background-color rgba(255,255,255,0.1)
      cursor pointer
      backdrop-filter blur(5px)
  @keyframes moveIn
    0%
      left 100%
    100%
      left 0
@media screen and (max-width: 1640px)
  .miya-purchasedDetails
    .table-data
      .qrcode
        font-size $f13
    .price-box
      .selection
        padding-left 12px
        .slection-box
          .btn-mutRenew
            margin-left 4px
      .pagination
        padding 17px 12px
@media screen and (max-width: 800px)
  .miya-purchasedDetails
    overflow-y auto
    .title1
      margin-bottom 1rem
      line-height 1.5rem
    .search-box
      display block
      .checkList
        width 100%
        margin-bottom 0.2rem
      .select-box, .search-input
        width 8rem
        display inline-block
      .select-box
        margin-right 0.5rem
    .table-data
      margin 1rem 0 4.5rem 0
    .price-box
      display block
      .selection
        padding 0.5rem
        .slection-box
          .selectText, .unit
            margin-right 0.5rem
            font-size 0.6rem
          .total
            font-size 0.8rem
          .unit
            font-size 0.5rem
          .btn-mutRenew, .btn-delete
            padding 0 0.5rem
            font-size 0.6rem
      .pagination
        padding 0.5rem
        .exportBtn
          margin-right 0.5rem
    .renewList
      padding 0
      .titleName
        margin 0.5rem 0 0.2rem 0
    .renew-footer
      padding 0.5rem 0
      .list
        .item
          margin-right 0.5rem
          padding 0.5rem
          .icon
            width 0.7rem
            margin-right 0.5rem
          .vx
            width 0.72rem
          .mc
            height 0.7rem
          .vs
            height 0.5rem
          span
            font-size 0.6rem
    .adyenContent
      position relative
      .close
        top -32px
        right -5px
</style>
<style lang="stylus">
.miya-purchasedDetails
  .el-button--info.is-disabled, .el-button--info.is-disabled:active, .el-button--info.is-disabled:focus, .el-button--info.is-disabled:hover
    background #D0CFCE
    border 1px solid #D0CFCE
  .el-button--primary
    background: linear-gradient(95deg, #FF8F10 0%, #FF7010 100%);
  .search-box
    .el-input__inner
      background-color $c7
    .el-input--medium .el-input__icon
      color $c1
      fontWeight()
  .el-table .el-table__cell
    padding 12px 0
  .el-table .cell
    padding-left 8px
    padding-right 8px
  .miya-checkList
    .item
      width 130px
  .btn-delete
    border 1px solid transparent
    background-color $c5
    color $c1
    &:hover
      background-color $c4
      color $c1
  .el-dialog__body
    padding 0 24px 0 24px
.el-popover
  min-width 100px
@media screen and (max-width: 800px)
  .miya-purchasedDetails
    .miya-checkList
      .item
        width 4.5rem
        margin-right 0.5rem
</style>
